import { store } from '../store'
import http from '../api/api'
import config from '../api/constants'

const getBalances = async () => {
  try {
    const reqParams = {
      requestId: 'GETBALANCES',
    }
    const response = await http.post(config.apiRoute.GET_BALANCES, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const getAccountClass = async () => {
  try {
    let reqParams={
      requestId: "GETACCOUNTCLASSDETAILS",
    }
    const response = await http.post(config.apiRoute.GET_ACCOUNT_CLASS, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw Promise.reject()
  }
}

const createCASAAccountVerify = async (req /*reqParams, accountDetails*/) => {
  try {
    const reqParams = {
      requestId: 'CREATEACCOUNTVERIFY',
      ...req,
    }
    const response = await http.post(config.apiRoute.CREATE_CASA_ACCOUNT_VERIFY, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw Promise.reject()
  }
}
const GetMT103RefNumbers = async (reqParams) => {
  try {
    const params = {
      contractRefNo: '',
      requestId: 'MT103MESSAGE',
      sourceAccount: reqParams.accountNumber,
      module: 'MT103',
    }
    const response = await http.post(config.apiRoute.GET_MT103_REFNUMBERS, params)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw Promise.reject()
  }
}

const GetListofFormat = async (accNO) => {
  try {
    const reqParams = { requestId: 'FORMATLIST' }
    const response = await http.post(config.apiRoute.GET_LIST_OF_FORMAT, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw Promise.reject()
  }
}
const createCASAAccountConfirm = async (req /*reqParams, accountDetails*/) => {
  try {
    const reqParams = {
      requestId: 'CREATEACCOUNTCONFIRM',
      ...req,
    }
    const response = await http.post(config.apiRoute.CREATE_CASA_ACCOUNT_CONFIRM, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const getAllOtherPayments = async () => {
  try {
    const reqParams = { requestId: 'INSTITUTIONSLIST' }
    const response = await http.post(config.apiRoute.GET_ALL_OTHER_PAYMENTS_LIST, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw Promise.reject()
  }
}

const getAllOtherStudentsName = async (formData) => {
  try {
    const reqParams = {
      ...formData,
      requestId: 'STUDENTDETAILS',
    }
    const response = await http.post(config.apiRoute.GET_STUDENT_NAME, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw Promise.reject()
  }
}

const otherBillPaymentVerify = async (formData, accountDetails) => {
  try {
    const reqParams = {
      requestId: 'SCHOOLPAYMENTSVERIFY',
      srcAccount: accountDetails.accountNo || 0,
      srcAccBranch: accountDetails.brnCode || 0,
      amount: formData.amount,
      institutionID: formData.otherBillPaymentId,
      institutionName: formData.institutionName,
      srcAccCcy: accountDetails.currency || '',
      remarks: formData.remarks,
      student_name: formData.student_name,
      studentID: formData.serviceNumber,
      destAccount: formData.destAccount,
      destAccBranch: formData.destAccBranch,
      destAccCcy: formData.destAccCcy,
    }
    const response = await http.post(config.apiRoute.OTHER_BILL_PAYMENTS_VERIFY, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const otherBillPaymentConfirm = async (formData, accountDetails) => {
  try {
    const reqParams = {
      requestId: 'SCHOOLPAYMENTS',
      srcAccount: accountDetails.accountNo,
      srcAccBranch: accountDetails.brnCode,
      amount: formData.amount,
      institutionID: formData.otherBillPaymentId,
      institutionName: formData.institutionName,
      srcAccCcy: accountDetails.currency,
      remarks: formData.remarks,
      student_name: formData.student_name,
      serviceNumber: formData.serviceNumber,
      otp: formData.otp,
      studentID: formData.serviceNumber,
      destAccount: formData.destAccount,
      destAccBranch: formData.destAccBranch,
      destAccCcy: formData.destAccCcy,
    }
    const response = await http.post(config.apiRoute.OTHER_BILL_PAYMENTS_CONFIRM, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const getAllUtilityPayments = async () => {
  try {
    const reqParams = {
      requestId: 'UTILITIESLIST',
    }
    const response = await http.post(config.apiRoute.GET_ALL_UTILITY_PAYMENTS_LIST, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const getAllUtilityStudentsName = async (formData) => {
  try {
    const reqParams = {
      ...formData,
      requestId: 'CUSTOMERDETAILS',
    }
    const response = await http.post(config.apiRoute.GET_UTILITY_STUDENT_NAME, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const otherUtilityPaymentVerify = async (formData, accountDetails) => {
  try {
    const reqParams = {
      requestId: 'UTILITYPAYMENTSVERIFY',
      srcAccount: accountDetails.accountNo || 0,
      srcAccBranch: accountDetails.brnCode || 0,
      amount: formData.amount,
      accountNumber: formData.serviceNumber,
      institutionName: formData.institutionName,
      srcAccCcy: accountDetails.currency || '',
      remarks: formData.remarks,
      customer_name: formData.customer_name,
      institutionID: formData.institutionID,
      destAccount: formData.destAccount,
      destAccBranch: formData.destAccBranch,
    }
    const response = await http.post(config.apiRoute.OTHER_UTILITY_PAYMENTS_VERIFY, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const otherUtilityPaymentConfirm = async (formData, accountDetails) => {
  try {
    const reqParams = {
      requestId: 'UTILITYPAYMENTS',
      otp: formData.otp,
      srcAccount: accountDetails.accountNo || 0,
      srcAccBranch: accountDetails.brnCode || 0,
      amount: formData.amount,
      accountNumber: formData.serviceNumber,
      institutionName: formData.institutionName,
      srcAccCcy: accountDetails.currency || '',
      remarks: formData.remarks,
      customer_name: formData.customer_name,
      institutionID: formData.institutionID,
      destAccount: formData.destAccount,
      destAccBranch: formData.destAccBranch,
    }
    const response = await http.post(config.apiRoute.OTHER_UTILITY_PAYMENTS_CONFIRM, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const rdCreateVerify = async (formData, accountDetails) => {
  try {
    const reqParams = {
      requestId: 'RDCREATE',
      rdAccDesc: formData.rdAccDesc,
      srcAccNo: accountDetails.accountNo,
      srcAccBrn: accountDetails.brnCode,
      srcCcy: accountDetails.currency,
      payInAmt: formData.payInAmt,
      frequencyDays: '',
      frequencyMonths: '1',
      frequencyYears: '',
      tenorDays: '',
      tenorMonths: formData.tenorMonths,
      tenorYears: '',
    }
    const response = await http.post(config.apiRoute.RD_CREATE_VERIFY, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const rdCreateConfirm = async (formData, accountDetails) => {
  try {
    const reqParams = {
      requestId: 'RDCREATE',
      rdAccDesc: formData.rdAccDesc,
      srcAccNo: accountDetails.accountNo,
      srcAccBrn: accountDetails.brnCode,
      srcCcy: accountDetails.currency,
      payInAmt: formData.payInAmt,
      frequencyDays: '',
      frequencyMonths: '1',
      frequencyYears: '',
      tenorDays: '',
      tenorMonths: formData.tenorMonths,
      tenorYears: '',
      otpNo: formData.otpNo,
      randomKey: formData.randomKey,
    }
    const response = await http.post(config.apiRoute.RD_CREATE_CONFIRM, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const getRemarksCategory = async () => {
  try {
    const reqParams = {
      requestId: 'REMARKLIST',
    }
    const response = await http.post(config.apiRoute.REMARKS_CATEGORY, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const serviceRequest = async (formData) => {
  const { app } = store.getState()
  try {
    const reqParams = {
      requestId: 'SERVICEREQUEST',
      category: formData.category,
      categoryEmail: '',
      emailId: app.profile.emailId,
      suggestion: formData.suggestion,
      referenceNo: formData.referenceNo,
      accountNo: formData.accountNo,
      beneName: formData.beneName,
      status: '',
      remarks: '',
      amount: formData.amount,
    }
    const response = await http.post(config.apiRoute.SERVICE_REQUEST, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const serviceRequestView = async () => {
  try {
    const reqParams = {
      requestId: 'SERVICEREQUEST',
      category: '',
      accountNo: '',
      status: '',
    }
    const response = await http.post(config.apiRoute.SERVICE_REQUEST_VIEW, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const DashboardService = {
  getBalances,
  getAccountClass,
  createCASAAccountVerify,
  GetMT103RefNumbers,
  GetListofFormat,
  createCASAAccountConfirm,
  getAllOtherPayments,
  getAllOtherStudentsName,
  otherBillPaymentVerify,
  otherBillPaymentConfirm,
  getAllUtilityPayments,
  getAllUtilityStudentsName,
  otherUtilityPaymentVerify,
  otherUtilityPaymentConfirm,
  rdCreateVerify,
  rdCreateConfirm,
  getRemarksCategory,
  serviceRequest,
  serviceRequestView
}

export default DashboardService